import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "pdfxstandards"
    }}>{`PDFXStandards`}</h1>
    <p>{`Options for specifying the PDF/X compliance standard.`}</p>
    <h2 {...{
      "id": "class"
    }}>{`Class`}</h2>
    <blockquote>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`NONE`}</strong>{` = 1852796517`}</p>
      <p parentName="blockquote">{`Does not check for compliance with a PDF/X standard.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`PDFX1A2001_STANDARD`}</strong>{` = 1396912481`}</p>
      <p parentName="blockquote">{`Checks for compliance with the PDF/X-1a:2001 standard.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`PDFX32002_STANDARD`}</strong>{` = 1396922419`}</p>
      <p parentName="blockquote">{`Checks for compliance with the PDF/X-3:2002 standard.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`PDFX1A2003_STANDARD`}</strong>{` = 1395745075`}</p>
      <p parentName="blockquote">{`Checks for compliance with the PDF/X-1a:2003 standard.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`PDFX32003_STANDARD`}</strong>{` = 1398289203`}</p>
      <p parentName="blockquote">{`Checks for compliance with the PDF/X-3:2003 standard.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`PDFX42010_STANDARD`}</strong>{` = 1398289496`}</p>
      <p parentName="blockquote">{`PDFX42010 standard is used.`}</p>
    </blockquote>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      